import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { UpdateVacancyError } from '../../errors';
import { ESubdomain } from '../../constants/domain';
import {
  fetchUpdateVacancy,
  IUpdateVacancyResponse200,
  IUpdateVacancyResponse400,
} from '../../repositories/vacancies/v1/update-vacancy';
import { IVacancy } from '../..';

export interface IUpdateVacancyDependencies {
  httpApi: IHttpApi;
  logger: ILogger;
  subdomain: ESubdomain;
}

export interface IUpdateVacancyParams {
  vacancy: IVacancy;
  recaptcha: string;
}

export const updateVacancy = async (deps: IUpdateVacancyDependencies, params: IUpdateVacancyParams) => {
  const { httpApi, logger, subdomain } = deps;
  const { vacancy, recaptcha } = params;

  try {
    const resp = await fetchUpdateVacancy<IUpdateVacancyResponse200, IUpdateVacancyResponse400>({
      httpApi,
      parameters: {
        captchaToken: recaptcha,
        vacancy: {
          description: vacancy.description,
          email: vacancy.contactEmail || null,
          employment: vacancy.employment,
          id: vacancy.id,
          maxSalary: vacancy.maxSalary || null,
          minExperience: vacancy.workExperience || null,
          minSalary: vacancy.minSalary || null,
          phone: vacancy.contactPhone || null,
          regionId: vacancy.region.id,
          specialization: vacancy.specialization,
        },
      },
      config: {
        requestConfig: {
          headers: [['Content-Type', 'application/x-www-form-urlencoded']],
        },
      },
    });

    if (resp.statusCode !== 200) {
      throw new UpdateVacancyError({
        subdomain,
        message: resp.response.message,
        details: {
          error: JSON.stringify(resp.response.errors),
        },
      });
    }
  } catch (e) {
    logger.error(e);
  }
};
